/**
 * The fetch wrapper, same shape as Studio's so the two read alike.
 *
 * Every call resolves — network failure included — because a preview tool that
 * throws on a dropped connection leaves the screen in whatever half-state the
 * caller was in. The error is a CODE, not a message: the catalogue turns it
 * into language, so a server string never reaches the user untranslated.
 */
async function request<T>(url: string, options?: RequestInit): Promise<{ data: T | null; error: string | null }> {
  try {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      ...options,
    })
    if (!res.ok) {
      const body = await res.json().catch(() => ({ error: 'UNKNOWN' })) as { error?: string }
      return { data: null, error: body.error ?? 'UNKNOWN' }
    }
    return { data: await res.json() as T, error: null }
  } catch {
    return { data: null, error: 'NETWORK_ERROR' }
  }
}

export const api = {
  get: <T>(url: string) => request<T>(url),
  post: <T>(url: string, body?: unknown) =>
    request<T>(url, { method: 'POST', ...(body === undefined ? {} : { body: JSON.stringify(body) }) }),
  patch: <T>(url: string, body?: unknown) =>
    request<T>(url, { method: 'PATCH', ...(body === undefined ? {} : { body: JSON.stringify(body) }) }),
}
